import InvoiceList from 'invoices/containers/InvoiceList'
import InvoiceDetail from 'invoices/containers/InvoiceDetail'

export const RouteConfig = [
  {
    path: '/invoices',
    component: InvoiceList,
  },
  {
    path: '/invoices/new',
    component: InvoiceDetail,
  },
  {
    path: '/invoices/:id',
    component: InvoiceDetail,
  },
]
